export const isHtmlReport = content =>
    !!content && !!content.data && typeof content.data === 'string'



// WEBPACK FOOTER //
// ./src/utils/dataSetReport/isHtmlReport.js